import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { ErrorMessage, SelectDropdown } from '@gsa/afp-component-library';
import EquipmentCode from './equipment-code';
import EquipmentCodeDescription from './equipment-code-description';
import AssociationSpecificationFields from './association-specification-fields';

const AssociationForm = ({
  control,
  errors,
  register,
  setValue,
  updateEquipmentCodeId,
  equipmentCodeId,
  equipmentAssociation = {},
  multipleOptions = [],
  programName,
  isStandardItemInBetweenBidPeriods = false,
  isSINInContractYear = false,
}) => {
  const isNew = equipmentAssociation?.id === undefined;

  const programOptions = multipleOptions.filter(
    (o) =>
      o.type === 'standardsCodeModel' &&
      o.uniqueKey === 'program' &&
      o.value === programName,
  );

  const canStandardItemPartialEdit =
    equipmentAssociation?.standardItem?.canPartialEdit;

  return (
    <>
      <div className="grid-row padding-bottom-2">
        <div className="grid-col-6">
          <h2 aria-label="Program" className="font-sans-xs">
            Program <span className="usa-hint usa-hint--required">*</span>
          </h2>
          {isNew && (
            <Controller
              id="ec_program"
              name="program"
              control={control}
              render={({ field: { value } }) => (
                <SelectDropdown
                  id="ec_program_sel"
                  data-testid="program"
                  aria-label="Program"
                  options={programOptions}
                  value={value}
                  disabled
                />
              )}
            />
          )}
          {!isNew && <> {equipmentAssociation?.equipmentCode.program} </>}
          {errors?.program?.message && (
            <ErrorMessage>{errors.program.message}</ErrorMessage>
          )}
        </div>
      </div>

      <EquipmentCode
        isNew={isNew}
        setEQcode={updateEquipmentCodeId}
        control={control}
        errors={errors}
        register={register}
        equipmentAssociation={equipmentAssociation}
        program={programName}
        setValue={setValue}
      />

      {isNew && equipmentCodeId && (
        <EquipmentCodeDescription equipmentCodeId={equipmentCodeId} />
      )}

      {!isNew && (
        <div className="grid-row padding-bottom-2">
          <div className="grid-col-6">
            <h2 className="font-sans-xs">Title</h2>
            {equipmentAssociation?.equipmentCode?.title}
          </div>
        </div>
      )}

      {!isNew && (
        <EquipmentCodeDescription
          equipmentCodeId={`${equipmentAssociation?.equipmentCode?.id}`}
          desc={equipmentAssociation?.equipmentCode?.content?.content}
        />
      )}

      <AssociationSpecificationFields
        control={control}
        errors={errors}
        setValue={setValue}
        equipmentAssociation={equipmentAssociation}
        multipleOptions={multipleOptions}
        isStandardItemInBetweenBidPeriods={isStandardItemInBetweenBidPeriods}
        canPartialEdit={canStandardItemPartialEdit}
        isInContractYear={isSINInContractYear}
        isNew={isNew}
      />
    </>
  );
};

AssociationForm.propTypes = {
  control: PropTypes.shape(Object).isRequired,
  errors: PropTypes.shape(Object).isRequired,
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  updateEquipmentCodeId: PropTypes.func.isRequired,
  equipmentCodeId: PropTypes.string.isRequired,
  equipmentAssociation: PropTypes.shape(Object),
  multipleOptions: PropTypes.arrayOf(Object),
  programName: PropTypes.string.isRequired,
  isStandardItemInBetweenBidPeriods: PropTypes.bool,
  isSINInContractYear: PropTypes.bool,
};

export default AssociationForm;
